import { Link } from 'react-router';

// Catch-all for unknown URLs. CloudFront rewrites 403/404 → index.html for SPA
// deep-link support, so a bad deep link loads the app and routes here instead of
// hitting react-router's default unstyled error page. Rendered inside the App
// shell (under ConstrainedLayout), so the header and page chrome stay put.
export function NotFound() {
  return (
    <div className="p-8 text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">404</p>
      <h1 className="mt-2 text-lg font-semibold text-slate-900">Page not found</h1>
      <p className="mt-2 text-sm text-slate-600">
        The page you&apos;re looking for doesn&apos;t exist or may have moved.
      </p>
      <Link to="/" className="mt-4 inline-block text-sm text-blue-600 underline">
        Back to jobs
      </Link>
    </div>
  );
}
